import { useParams } from "react-router-dom"
import CommonPayoutTable from "../commonfile/CommonPayoutTable";
import { NormalContainerWithHeader } from "../../shared/components/student/NormalComponent";
import CustomDivider from "../../shared/utils/CustomDivider";
import AddPayoutForm from "./AddPayoutForm";
import { Constants, Grid_Gap, Input_Width } from "../../shared/constants";
import { useAdminApartmentList, useApartmentListForCourse, useMarketingList, usePayoutList } from "../../assets/api/useAdminApi";
import CommonMarketingTable from "../commonfile/CommonMarketingTable";
import AddMarketingForm from "./AddMarketingForm";
import CommonContactPersonTable from "../commonfile/CommonContactPersonTable";
import CommonContactPerson from "../commonfile/CommonContactPerson";
import CommonTermAndConditionForm from "../commonfile/CommonTermAndConditionForm";
import { AutoCompleteField } from "../../shared/components/formfields/AutoCompleteField";
import { Field, Form, Formik } from 'formik'
import * as Yup from 'yup'
import { useMutation, useQueryClient } from "@tanstack/react-query";
// import api from "../../assets/api/useStudentPostApi";
import { Box, Button, Grid2, Typography } from "@mui/material";
import { useToaster } from "../../shared/utils/ToasterProvider";
import useAuthStore from "../../store/useAuthStore";
import { TextFormField } from "../../shared/components/formfields/TextFormField";
import { useState } from "react";
import usePayoutStore from "../../store/usePayoutStore";
import useMarketingDetailStore from "../../store/useMarketingDetailStore";
import useContactPersonStore from "../../store/useContactPersonStore";
import StudentCourseTable from "../commonfile/StudentCourseTable";
import AccountHistoryTable from "../apartment/AccountHistoryTable";
import AdminToolbar from "./components/AdminToolbar";
import MainDialogBox from "../../shared/components/Dialog/MainDialogBox";
import { DateFormField } from "../../shared/components/formfields/DataFormField";
import { useDialog } from "../../shared/hook/useDialog";
import CommonAddPayout from "../commonfile/CommonAddPayout";
import CommonAddMarketing from "../commonfile/CommonAddMarketing";
import TermAndConditionTable from "../apartment/TermAndConditionTable";
import CommonTermAndConditionTable from "../commonfile/CommonTermAndConditionTable";
import api from "../../assets/nodeApi/axiosInstance";


const AparmentDetail = () => {
    const [isShowContact, setIsShowContact] = useState(false)
    const { contactperson } = useContactPersonStore()
    const { token } = useAuthStore()
    const { id } = useParams()
    const queryClient = useQueryClient();
    const { data: apartmentlist, isLoading } = useAdminApartmentList()
    const matchedApartment = apartmentlist?.data?.find(item => item.id == id);
    const { data: apartmentList, isLoading: isLoadingApartmentList } = useApartmentListForCourse();
    const ApartmentOptions = apartmentList?.data?.map((item) => ({
        id: item?.id,
        label: item?.apartment_name,
        value: item?.apartment_name,
    })) || [];
    const { showToaster } = useToaster();
    const validationSchema = Yup.object().shape({});
    const initialValues = {
        new_status: matchedApartment?.apartment_status || "",
        remarks: matchedApartment?.remarks || "",
    };

    const mutation = useMutation({
        mutationFn: (formData) => {
            return api.put(`apartment/update-status/${id}`, formData,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                }
            );
        },
        onSuccess: (response) => {
            showToaster('Success', response?.data?.message, 'success')
            queryClient.invalidateQueries({ queryKey: ['get-all-apartments-list'] });
        },
        onError: () => {
            showToaster("Error Caught While submiting the form", 'Error', 'error');
        },
    });
    const handleSubmit = (values, { setSubmitting, resetForm }) => {
        mutation.mutate(values, {
            onSettled: () => {
                setSubmitting(false);
            },
            onSuccess: () => {
                resetForm();
            }
        });
    }

    const options = [
        {
            id: 1,
            value: "New",
            label: "New"
        },
        {
            id: 2,
            value: "Positive",
            label: "Positive"
        },
        {
            id: 3,
            value: "Inprogress",
            label: "Inprogress"
        },
        {
            id: 4,
            value: "Onboarded",
            label: "Onboarded"
        },
        {
            id: 5,
            value: "Not Interested",
            label: "Not Interested"
        },
        {
            id: 6,
            value: "Wrong Number",
            label: "Wrong Number"
        },
        {
            id: 7,
            value: "Call Back",
            label: "Call Back"
        },
    ]


    return (
        <>
            <Typography variant="h3">Apartment Name - {matchedApartment?.apartment_name}</Typography>
            <CustomDivider />
            <NormalContainerWithHeader headerText={"Edit Status"}>
                <Formik
                    initialValues={initialValues}
                    validationSchema={validationSchema}
                    onSubmit={handleSubmit}
                    enableReinitialize={true}
                >
                    {({ resetForm }) => (
                        <Form>
                            <Grid2 container spacing={Grid_Gap}>
                                <Grid2 children size={Input_Width}>
                                    <Field
                                        name="new_status"
                                        component={AutoCompleteField}
                                        options={options}
                                        label="Status"
                                        type={"number"}
                                    />
                                </Grid2>
                                <Grid2 children size={Input_Width}>
                                    <Field
                                        name="remarks"
                                        component={TextFormField}
                                        label="Remark"

                                    />
                                </Grid2>
                            </Grid2>
                            <CustomDivider />
                            <Grid2 container spacing={Grid_Gap}>
                                <Grid2 children size={Input_Width}>
                                    <Button variant='contained' onClick={resetForm} fullWidth>
                                        Cancel
                                    </Button>
                                </Grid2>
                                <Grid2 children size={Input_Width}>
                                    <Button variant='contained' type='submit' fullWidth>Edit</Button>
                                </Grid2>
                            </Grid2>
                        </Form>
                    )}
                </Formik>
            </NormalContainerWithHeader>
            <CustomDivider />
            <NormalContainerWithHeader headerText={"Course List"}>
                <StudentCourseTable id={id} />
            </NormalContainerWithHeader>

            <CustomDivider />

            <NormalContainerWithHeader headerText={"Add Terms And Condition"}>
                <CommonTermAndConditionForm id={id} />
            </NormalContainerWithHeader>
            <CustomDivider />
            <CommonTermAndConditionTable id={id} />


            <CustomDivider />
            {/* <NormalContainerWithHeader headerText={"Payout List"} RightContent={
                <Box sx={{ display: "flex", gap: 2 }}>
                    <AdminToolbar
                        // onSearchChange={handleSearchChange}
                        onFilterClick={handleClickOpen}
                        filterIcon={Constants.customImages.FilterDark}
                    />
                    {!(payoutDetail?.id || isShowPayout) && (
                        <Button variant="outlined" onClick={() => setIsShowPayout(true)}>Add</Button>
                    )
                    }


                </Box>
            }>
                {
                    (isShowPayout || payoutDetail?.id) && <AddPayoutForm inputWidth={Input_Width} ApartmentOption={ApartmentOptions} isLoadingApart={isLoadingApartmentList} isOneApartmentView={true} />
                }

                <CustomDivider />
                <CommonPayoutTable id={id} payoutRows={payoutRows} isLoading={isPayoutListLoading} />
            </NormalContainerWithHeader> */}
            <CommonAddPayout id={id} />
            <CustomDivider />
            {/* <NormalContainerWithHeader headerText={"Marketing "} RightContent={
                <Box sx={{ display: "flex", gap: 2 }}>
                    <AdminToolbar
                        // onSearchChange={handleSearchChange}
                        onFilterClick={handleClickOpenad}
                        filterIcon={Constants.customImages.FilterDark}
                    />
                    {
                        !(marketingDetail?.id || isShowMarketing) && (
                            <Button variant="outlined" onClick={() => setIsShowMarketing(true)}>Add</Button>
                        )
                    }
                </Box>
            }
            >
                {
                    (isShowMarketing || marketingDetail?.id) &&
                    <AddMarketingForm inputWidth={Input_Width} ApartmentOption={ApartmentOptions} isLoadingApart={isLoadingApartmentList} />
                }
                <CustomDivider />
                <CommonMarketingTable id={id} marketingadRows={marketingadRows} isLoading={isMarketingLoading} />
            </NormalContainerWithHeader> */}
            <CommonAddMarketing id={id} />
            <CustomDivider />

            <NormalContainerWithHeader headerText={"Contact Person List"} RightContent={
                !(contactperson?.id || isShowContact) && (
                    <Button variant="outlined" onClick={() => setIsShowContact(true)}>Add</Button>
                )
            }>
                {
                    (isShowContact || contactperson?.id) &&
                    <CommonContactPerson ApartmentOption={ApartmentOptions} isLoadingApart={isLoadingApartmentList} />
                }
                <CustomDivider />
                <CommonContactPersonTable id={id} />

            </NormalContainerWithHeader>

            <CustomDivider />
            <NormalContainerWithHeader headerText={"Contact History"}>
                <AccountHistoryTable id={id} />
            </NormalContainerWithHeader>
        </>
    )
}

export default AparmentDetail